// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderSearchStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    container: {
        gap: 10,
        offsetCss: css`
            align-items: flex-start;
            ${xScreen("lte", "sm")} {
                align-items: flex-end;
            }
        `,
    },
    searchGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            position: relative;
        `,
    },
    qtyGridItem: { width: [6, 3, 2, 1, 1] },
    unitOfMeasureGridItem: { width: [6, 4, 2, 2, 2] },
    buttonGridItem: {
        width: [6, 4, 4, 4, 4],
        css: css`
            justify-content: flex-start;
            align-items: flex-start;
            &&& {
                margin-top: 17px;
                ${xScreen("lt", "sm")} {
                    margin-top: 0;
                }
            }
        `,
    },
    selectButton: {
        css: css`
            &&& {
                min-height: 37px;
                margin-top: 0;
                margin-bottom: 0;
            }
            ${xScreen("lte", "xs")} {
                &&& {
                    margin-top: 21px;
                    width: 100%;
                }
            }
        `,
    },
    clearIcon: {
        size: 18,
        css: css`
            position: absolute;
            right: 35px;
            top: 31px;
            cursor: pointer;
        `,
    },
};
